// import debounce from './debounce';

import $ from 'jquery';

import Cookie from './cookie';

function dispatch() {
  document.dispatchEvent(
    new CustomEvent('theme:resize', {
      bubbles: true,
    })
  );
}

const cookieConfig = {
  expires: 1,
  name: 'smo_countdown_timer_202209',
};

function countdownTimer() {
  const cookie = new Cookie(cookieConfig);

  $(`[data-countdown-timer]`).each(function(){
    const $el = $(this);

    let compareTimestamp = $el.attr('data-timestamp'),
        compareTimestampCookieArray = cookie.read(),
        countdownTextBefore = $el.attr('data-text-before') || '',
        countdownTextAfter = $el.attr('data-text-after') || '',
        showUnit = $el.attr('data-show-unit') == 'true',
        displayFormat = $el.attr('data-display-format') || '',
        compareDate = new Date(compareTimestamp * 1000),
        currentDate = new Date();

    // console.log({
    //   'compareTimestampCookieArray': compareTimestampCookieArray,
    //   'compareTimestamp': compareTimestamp
    // })

    if( compareTimestamp.indexOf(`-`) !== -1 ) {
      const timestampInputs = compareTimestamp.split('-');

      if ( compareTimestampCookieArray.length === 0 || compareTimestampCookieArray[0] === 'null' ) {

        // Calculate compareDate basing on the currentDate
        compareTimestamp = generateCompareTimestamp( timestampInputs );
        compareDate = new Date(compareTimestamp * 1000);

        // Update or destory cookie.
        cookie.write(compareTimestamp);
      } else {
        compareTimestamp = compareTimestampCookieArray[0];
        compareDate = new Date(compareTimestamp * 1000);
        if( currentDate > compareDate ) {
          cookie.destroy();

          // Calculate compareDate basing on the currentDate
          compareTimestamp = generateCompareTimestamp( timestampInputs );
          compareDate = new Date(compareTimestamp * 1000);
        }
      }
    }


    if( currentDate > compareDate ||
      $el.hasClass('countdown-initialized') ) {
      return;
    }

    setInterval(function(){
      currentDate = new Date();
      let cs = '',
          diffSecs = Math.floor((compareDate - (currentDate))/1000),
          diffMins = Math.floor(diffSecs/60),
          diffHrs = Math.floor(diffMins/60),
          diffDays = Math.floor(diffHrs/24);
      diffHrs = diffHrs - (diffDays*24);
      diffMins = diffMins - (diffDays*24*60) - (diffHrs*60);
      diffSecs = diffSecs - (diffDays*24*60*60) - (diffHrs*60*60) - (diffMins*60);

      switch (displayFormat) {
        case 'unit_below':
          cs = `<div class="countdown-timer-items">
                  <span class="countdown-timer-item">${((diffDays<10) ? '0'+diffDays : diffDays )}<span class="countdown-timer-item-label">Days</span></span>
                  <span class="countdown-timer-item">${((diffHrs<10) ? '0'+diffHrs : diffHrs)}<span class="countdown-timer-item-label">Hours</span></span>
                  <span class="countdown-timer-item">${((diffMins<10) ? '0'+diffMins : diffMins)}<span class="countdown-timer-item-label">Min</span></span>
                  <span class="countdown-timer-item">${((diffSecs<10) ? '0'+diffSecs : diffSecs)}<span class="countdown-timer-item-label">Sec</span></span>
                </div>`;
          break;

        case 'hms':
          cs = `${((diffHrs<=1) ? diffHrs+' hour' : diffHrs+' hours')}, ${((diffMins<10) ? '0'+diffMins : diffMins)} minutes, ${((diffSecs<10) ? '0'+diffSecs : diffSecs)} seconds`;
          break;

        default:
          if(showUnit) {
            // cs = `${((diffDays<=1) ? diffDays+' day' : diffDays+' days')}, ${((diffHrs<10) ? '0'+diffHrs : diffHrs)}h ${((diffMins<10) ? '0'+diffMins : diffMins)}m ${((diffSecs<10) ? '0'+diffSecs : diffSecs)}s`;
            cs = `${((diffDays<1) ? '' : ((diffDays==1) ? '<span>'+diffDays+'</span>d:' : '<span>'+diffDays+'</span>d:'))}${((diffHrs<10) ? '<span>0'+diffHrs+'</span>' : '<span>'+diffHrs+'</span>')}h:${((diffMins<10) ? '<span>0'+diffMins+'</span>' : '<span>'+diffMins+'</span>')}m:${((diffSecs<10) ? '<span>0'+diffSecs+'</span>' : '<span>'+diffSecs+'</span>')}s`;
          } else {
            cs += ((diffDays<10) ? '0'+diffDays : diffDays ) + ':';
            cs += ((diffHrs<10) ? '0'+diffHrs : diffHrs) + ':';
            cs += ((diffMins<10) ? '0'+diffMins : diffMins) + ':';
            cs += (diffSecs<10) ? '0'+diffSecs : diffSecs;
          }
      }

      $el.show().addClass('countdown-initialized');
      if( currentDate > compareDate ) {
        $el.hide();
      }
      $el.html(`<span class="countdown-timer-label countdown-timer-label--before">${countdownTextBefore}</span>${cs}<span class="countdown-timer-label countdown-timer-label--after">${countdownTextAfter}</span>`);
    }, 1000);
  });
}

function generateCompareTimestamp(timestampInputs) {
  let compareTimestamp = parseInt( Date.now()/1000 );
  for( var i=0 ; i<timestampInputs.length ; i++ ) {
    var input = parseInt(timestampInputs[i]);
    switch(i) {
      case 0:
        compareTimestamp += input * (24 * 60 * 60);
        break;
      case 1:
        compareTimestamp += input * (60 * 60);
        break;
      case 2:
        compareTimestamp += input * (60);
        break;
      case 3:
        compareTimestamp += input;
        break;
      default:
    }
  }
  return compareTimestamp;
}

export default countdownTimer;
